const $ = require( 'jquery' );
import slick from 'slick-carousel';

$(function() {
  initTimelineSlider();
}, jQuery);

function initTimelineSlider() {
  const timelineSlider = $('.timeline-slider');

  timelineSlider.slick({
    dots: true,
    infinite: false,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: '<button type="button" class="slick-prev" aria-label="Previous Slide"><svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64"><g id="icon_play_24x24" data-name="icon play 24x24" transform="translate(64 64) rotate(180)"><g id="icon_play_24x24-2" data-name="icon play 24x24" opacity="0.5"><g id="Group_1002" data-name="Group 1002"><path id="Path_857" data-name="Path 857" d="M32,0A32,32,0,1,0,64,32,32.036,32.036,0,0,0,32,0m0,62A30,30,0,1,1,62,32,30.035,30.035,0,0,1,32,62" fill="#2499a9"/><path id="Path_859" data-name="Path 859" d="M27.4,18.181,11.371,8.8a1.156,1.156,0,0,0-1.582.413,1.143,1.143,0,0,0-.16.583V28.566a1.157,1.157,0,0,0,1.156,1.156,1.1,1.1,0,0,0,.586-.16L27.4,20.173a1.154,1.154,0,0,0,0-1.992Zm-15.46,8.371V11.811L24.531,19.18Z" transform="translate(14.726 12.962)" fill="#2499a9"/></g></g></g></svg></button>',
    nextArrow: '<button type="button" class="slick-next" aria-label="Next Slide"><svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64"><g id="icon_play_24x24" data-name="icon play 24x24"><g id="icon_play_24x24-2" data-name="icon play 24x24" opacity="0.5"><g id="Group_1002" data-name="Group 1002"><path id="Path_857" data-name="Path 857" d="M32,0A32,32,0,1,0,64,32,32.036,32.036,0,0,0,32,0m0,62A30,30,0,1,1,62,32,30.035,30.035,0,0,1,32,62" fill="#2499a9"/><path id="Path_859" data-name="Path 859" d="M27.4,18.181,11.371,8.8a1.156,1.156,0,0,0-1.582.413,1.143,1.143,0,0,0-.16.583V28.566a1.157,1.157,0,0,0,1.156,1.156,1.1,1.1,0,0,0,.586-.16L27.4,20.173a1.154,1.154,0,0,0,0-1.992Zm-15.46,8.371V11.811L24.531,19.18Z" transform="translate(14.726 12.962)" fill="#2499a9"/></g></g></g></svg></button>',
    dots: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          adaptiveHeight: true
        }
      }
    ]
  });
}